import styled from '@emotion/styled'
export const NumberWithLabel = styled('div')`
    display: flex;
    flex-direction: column;
    text-decoration: none;
    place-items: center;
    align-items: center;
    justify-content: center;

    h2 {
        color: ${({ color }) => `var(--colors-${color})`};
        margin: 0;
        font-size: 1.4rem;
        font-weight: bold;
    }
`
